import React, { memo } from 'react';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { colorBorder, fontNumber, borderProduct, fields, stickyCol } from './Common';

type RecordItemProps = {
  items: any[];
  onClickRow?: (id: number) => void;
};

const RecordItem: React.FC<RecordItemProps> = (props) => {

  const handleClickRow = (id: string | number | undefined) => () => {
    if (id) {
      props.onClickRow?.(Number(id));
    }
  };

  return (
    <>
      {props.items.map((item: any, index: number) => (
        fields.map((field, indexField: number) => (
          <TableRow
            hover
            key={`row ${index}-${indexField}`}
            sx={{
              '&:last-child td, &:last-child th': { border: 0 },
              '& .MuiTableCell-root.MuiTableCell-body': {
                p: '0px 16px',
                borderBottom: indexField === fields.length - 1 ? `3px solid ${colorBorder}` : `1px solid ${colorBorder}`,
                borderRight: `1px solid ${colorBorder}`,
                fontSize: '12px',
                fontWeight: 400,
                lineHeight: '14.4px',
                ...(indexField === 0 ? {
                  '&:nth-of-type(1)': stickyCol(0, false),
                  '&:nth-of-type(2)': stickyCol(240, false),
                  '&:nth-of-type(3)': stickyCol(310, false)
                } : {
                  '&:nth-of-type(1)': stickyCol(310, false)
                })
              },
              height: '36px',
            }}
          >

            {indexField === 0 && (
              <React.Fragment key={indexField}>
                <TableCell
                  onClick={handleClickRow(item.productid)}
                  component='td'
                  scope='row'
                  rowSpan={3}
                  sx={{
                    minWidth: '240px',
                    maxWidth: '240px',
                    ...borderProduct,
                    cursor: 'pointer'
                  }}>
                  <Stack direction={'row'} spacing={'10px'}>
                    <Typography
                      sx={{
                        fontWeight: '700',
                        fontSize: '12px',
                        lineHeight: '14px',
                        color: '#23B7E5 !important',
                        cursor: 'pointer',
                        alignContent: 'center'
                      }}
                      component={'label'}
                    >
                      {item.product}
                    </Typography>
                    {Number(item.balance) <= 0 && (
                      <Box
                        sx={{
                          minWidth: '52px',
                          height: '20px',
                          border: '1px solid #DA4453',
                          borderRadius: '4px',
                          display: 'flex',
                          justifyContent: 'center'
                        }}
                      >
                        <Typography
                          sx={{
                            alignContent: 'center',
                            fontWeight: '400',
                            fontSize: '10px',
                            lineHeight: '12px',
                            color: '#DA4453',
                            cursor: 'pointer'
                          }}
                          component={'label'}
                        >
                          在庫切れ
                        </Typography>
                      </Box>
                    )}
                  </Stack>
                </TableCell>

                <TableCell
                  component='td'
                  scope='row'
                  rowSpan={3}
                  align='right'
                  sx={{
                    ...borderProduct
                  }}
                >
                  <Typography
                    sx={{
                      ...fontNumber
                    }}
                    component={'label'}
                  >
                    {item.balance}
                  </Typography>
                </TableCell>
              </React.Fragment>
            )}

            <TableCell align='center' component='td' scope='row'>
              <Typography
                sx={{
                  fontWeight: '400',
                  fontSize: '10px',
                  lineHeight: '12px'
                }}
                component={'label'}
              >
                {field.name}
              </Typography>
            </TableCell>

            {item.datas && item.datas.map((data: any, indexData: number) => (
              <TableCell key={'days ' + indexData} align='right' component='td' scope='row'>
                <Typography
                  sx={{
                    ...fontNumber
                  }}
                  component={'label'}
                >
                  {data[field.field] ? data[field.field] : ''}
                </Typography>
              </TableCell>
            ))}

            {indexField === 0 && (
              <TableCell
                component='td' align='right' scope='row'
                rowSpan={3}
                sx={{
                  ...borderProduct
                }}
              >
                <Typography
                  sx={{
                    ...fontNumber
                  }}
                  component={'label'}
                >
                  {item.latestbalance}
                </Typography>
              </TableCell>
            )}
          </TableRow>
        ))
      ))}
    </>
  );
};

const RecordItemMemo = memo(RecordItem);

export default RecordItemMemo;
